@if (formGroup) {
  <form (ngSubmit)="onSubmit()" [formGroup]="formGroup" class="form-container" id="register-form">
    <div id="titleHeader" class="title-header flex-row">
      <span class="flex-1">
        {{ isCreate ? ("responsible.item.createNew" | translate) : selectedItem.orgDescription }}
      </span>
      <button class="icon-button icon-close" mat-dialog-close="" type="button"></button>
    </div>
    <div class="scroll-container">
      <div class="content">
        <section class="form-section">
          <label>{{ "users.main.information" | translate }}</label>
          @if (!parentItem?.orgCode && !parentItem?.responsibleType) {
            <div class="flex-row">
              <div class="flex-1 form-cell">
                <sag-ui-select formControlName="responsibleType" [label]="'responsible.item.responsibleType' | translate">
                  @for (type of [ResponsibleType.sag, ResponsibleType.rc]; track type) {
                    <sag-ui-option [value]="type">
                      {{ "responsible.item.types." + type | translate }}
                    </sag-ui-option>
                  }
                </sag-ui-select>
              </div>
              <div class="flex-2"></div>
            </div>
          }
          <div class="flex-row">
            <div class="flex-1 form-cell">
              <sag-ui-input formControlName="orgCode" [required]="true" [label]="'Org Code'" />
            </div>
            <div class="flex-1 form-cell">
              <sag-ui-input formControlName="areCode" [label]="'ARE Code'" />
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 form-cell">
              <sag-ui-input formControlName="orgDescription" [required]="true" [label]="'organisation.create.orgDescription' | translate" />
            </div>
          </div>
          @if (!isSag) {
            <div class="flex-row">
              <div class="flex-1 form-cell">
                <reporting-tool-chip
                  (ngModelChange)="changeAssignedCountries($event)"
                  [removable]="true"
                  formControlName="assignedCountries"
                  placeholder="responsible.item.assignedCountries" />
              </div>
            </div>
          }
        </section>
        <section class="form-section form-section--dark">
          <label>{{ "responsible.item.executiveMember" | translate }}</label>
          <div class="flex-row">
            @if (IS_TRS_PROJECT) {
              <div class="flex-1 form-cell">
                <reporting-tool-user-picker
                  [exclude]="selectedUsers"
                  [multiple]="true"
                  [maxLength]="1"
                  [required]="true"
                  formControlName="mainResponsible"
                  placeholder="responsible.item.signFunction" />
              </div>
              <div class="flex-1 form-cell">
                <reporting-tool-user-picker
                  [exclude]="selectedUsers"
                  [multiple]="true"
                  [required]="false"
                  [maxLength]="2"
                  formControlName="otherResponsible"
                  placeholder="responsible.item.otherFunction" />
              </div>
            } @else if (IS_PRODUCT_SAFETY_PROJECT) {
              <div class="flex-1 form-cell">
                <reporting-tool-user-picker
                  [exclude]="selectedUsers"
                  [multiple]="true"
                  [required]="true"
                  formControlName="mainResponsible"
                  placeholder="responsible.item.signFunction" />
              </div>
              <div class="flex-1 form-cell">
                <reporting-tool-user-picker
                  [exclude]="selectedUsers"
                  [multiple]="true"
                  [required]="false"
                  formControlName="otherResponsible"
                  placeholder="responsible.item.otherFunction" />
              </div>
            }
          </div>
        </section>
        <section class="form-section">
          <label>{{ "responsible.item.specialistFunction" | translate }}</label>
          <div class="flex-row">
            <div class="flex-1 form-cell">
              <reporting-tool-user-picker
                [exclude]="selectedUsers"
                [multiple]="true"
                [required]="true"
                formControlName="mainSpecialists"
                placeholder="responsible.item.signFunction" />
            </div>
            <div class="flex-1 form-cell">
              <reporting-tool-user-picker
                [exclude]="selectedUsers"
                [multiple]="true"
                [required]="false"
                formControlName="otherSpecialists"
                placeholder="responsible.item.otherFunction" />
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="form-button-container">
      <sag-ui-button type="submit">
        {{ "default.buttons.save" | translate }}
      </sag-ui-button>
    </div>
  </form>
}
